import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  ElementRef,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PageEvent } from '@angular/material/paginator';
import { ToastrService } from 'ngx-toastr';
import { Subscription, interval } from 'rxjs';
import { HttpClient } from '@angular/common/http'; // Import HttpClient
import { ToasterMessages } from 'src/app/shared/constants/constants';
import {
  getMonthlyConditionOptions,
  getSegmentOptions,
  getmonths,
  getvesselOptions,
} from 'src/app/shared/helpers/Drop-down-options';
import { MonthlyReportService } from 'src/app/shared/service/monthly-report.service';
import { RequestFormService } from 'src/app/shared/service/requestForm/request-form.service';
import { MatSort, Sort } from '@angular/material/sort';

import { MatTableDataSource } from '@angular/material/table';
import { OverlapService } from 'src/app/shared/service/overlapService/overlap.service';
import { PeriodicPopupComponent } from './periodic-popup/periodic-popup.component';
import { PdfMergeDialogComponent } from './pdf-merge-dialog/pdf-merge-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { DashboardService } from 'src/app/shared/service/dashboard/dashboard.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-periodic-report',
  templateUrl: './periodic-report.component.html',
  styleUrls: ['./periodic-report.component.scss'],
})
export class PeriodicReportComponent {
  shipNameSuggestions: any[] = [];
  @ViewChild(MatSort) sort!: MatSort;
  paginatedData: any[] = [];
  addRowdData: any[] = [];
  itemsPerPage: number = 100;
  currentPage: number = 0;
  filterForm!: FormGroup;
  vesselOptions: any;
  tableData: any[] = [];
  addRowBtn: boolean = true;
  generateReport: boolean = false;
  toggleView: boolean = false;
  @ViewChild('fileInput') fileInput: ElementRef | undefined;
  username: any;
  clientOptions: any = ['Eiger Shipping', 'Zeronorth ZN', 'Elite Shipping'];
  vesselData: any = [];
  selectedFile: any;
isLoadingTable: boolean = false;
  isFilterOpen: boolean = false;
  constructor(
    private toastr: ToastrService,
    private fb: FormBuilder,
    private requestFormService: RequestFormService,
    private dialog: MatDialog,
    private sharedDataService: DashboardService,
    private router: Router,
    private overlayService: OverlapService,
    private http: HttpClient
  ) {
    this.filterForm = this.fb.group({
      from_date: ['', [Validators.required]],
      to_date: ['', [Validators.required]],
      vessel: ['', [Validators.required]],
    });
  }

  ngOnInit() {
    this.isLoadingTable = true;
    this.username = localStorage.getItem('username');
    this.requestFormService.getPeriodicReports().subscribe((data) => {
      console.log(data);
      this.tableData = data.data;
      this.paginateData();
      this.isLoadingTable = false;
    });
  }

  filterShipNames(event: Event): void {
    const inputValue = (event.target as HTMLInputElement).value;
    if (inputValue.length > 0) {
      this.shipNameSuggestions = this.vesselData.filter((item: any) =>
        item.vessel_name.toLowerCase().includes(inputValue)
      );
    } else {
      this.shipNameSuggestions = [];
    }
  }
  getData() {}

  paginateData() {
    const startIndex = this.currentPage * this.itemsPerPage;
    this.paginatedData = this.tableData.slice(
      startIndex,
      startIndex + this.itemsPerPage
    );
  }

  onPageChange(event: PageEvent) {
    this.currentPage = event.pageIndex;
    this.itemsPerPage = event.pageSize;
    this.paginateData();
  }

  isDarkMode() {
    return this.requestFormService.isDarkMode();
  }

  filterClick() {
    const from_date_str = this.filterForm.get('from_date')?.value;
    const to_date_str = this.filterForm.get('to_date')?.value;
    const vessel = this.filterForm.get('vessel')?.value;

    const filteredData = this.tableData.filter((element) => {
      const fromDateValid =
        !from_date_str || element.from_date >= from_date_str;
      const toDateValid = !to_date_str || element.to_date <= to_date_str;
      const segmentValid =
        !vessel || element.vessel?.toLowerCase() === vessel.toLowerCase();

      return fromDateValid && toDateValid && segmentValid;
    });
    this.paginatedData = filteredData;
    console.log(filteredData);
  }

  clearClick() {
    this.filterForm.reset();
    this.getData();
  }

  showDetails(row: any) {
    this.sharedDataService.setperiodicRowDat(row);
    this.router.navigate(['/vp-periodicReport']);
  }
  backClick() {
    this.router.navigate(['/vp-periodicReport']);
  }
  addRow() {
    const newRowSNo = this.paginatedData.length + 1;
    this.addRowdData.push({ sNo: newRowSNo });
    this.addRowBtn = false;
    this.generateReport = true;
  }

  generate(row: any) {
    const warrantedSpeedArray = row.warranted_speed.split(',').map(Number);
    let payload = {
      from: row.from,
      to: row.to,
      vessel: row.vessel,
      warranted_speed: warrantedSpeedArray,
    };
    console.log(payload);
    this.dialog.open(PeriodicPopupComponent, {
      width: '1087px',
      height: '500px',
      disableClose: true,
    });
  }

  openMergeConvertDialog() {
    const dialogRef = this.dialog.open(PdfMergeDialogComponent, {
      width: '600px',
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.endpoint && result.formData) {
        this.toastr.info('Your reports are being processed in the background. You will be notified when ready.');
        
        this.http.post(result.endpoint, result.formData, { responseType: 'blob' }).subscribe({
          next: (blob: Blob) => {
            this.toastr.success('Reports processed successfully!');
            // Auto open the PDF preview modal
            this.overlayService.showPdf(blob);
            
            // Also trigger standard download
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = 'Merged_Report.pdf';
            a.click();
            window.URL.revokeObjectURL(url);
          },
          error: (err) => {
            console.error('Error processing PDFs', err);
            this.toastr.error('Failed to merge/convert PDFs. Please ensure all uploaded files belong to the same vessel.');
          }
        });
      }
    });
  }

  toggleExistingView() {
    this.toggleView = !this.toggleView;
  }
  onFileSelected(event: any) {
    const file: File = event.target.files[0];
    if (file) {
      const extension = file.name.split('.').pop()?.toLowerCase();
      if (
        extension === 'xls' ||
        extension === 'xlsx' ||
        extension === 'xlsm' ||
        extension === 'csv'
      ) {
        this.selectedFile = file;
        this.toastr.success(ToasterMessages.FileUpload);
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          const base64File = reader.result as string;
          // Store the base64 string in local storage
          localStorage.setItem('uploadedFile', base64File);
          localStorage.setItem('uploadedFileName', file.name);
          if (base64File) {
            const dialogRef = this.dialog.open(PeriodicPopupComponent, {
              width: '1087px',
              height: '500px',
              disableClose: true,
            });
            dialogRef.afterClosed().subscribe((result) => {
              if (result) {
                this.dataToPass = result;
                console.log(this.dataToPass, 'result...........');
              }
            });
          }
        };
      } else {
        this.toastr.warning(ToasterMessages.FileWarning);
      }
    }
  }
  dataToPass(dataToPass: any, arg1: string) {
    throw new Error('Method not implemented.');
  }
  uploadfile() {
    if (this.fileInput) {
      (this.fileInput.nativeElement as HTMLInputElement).click();
    }
  }
  downloadIcon(row: any) {
    const pdf = row.periodic_s3_link;
    if (pdf) {
      this.toastr.success(ToasterMessages.PdfProcessing);
      this.requestFormService.downloadPeriodicReport(pdf).subscribe((data) => {
        this.overlayService.showPdf(data);
        this.toastr.clear();
      });
    } else {
      this.toastr.success(ToasterMessages.RecordNotFount);
    }
  }
  downloadSummaryIcon(row: any) {
    const parts = row.s3_periodic_link.split('/');
    const pdfFileName = parts[parts.length - 1];
    const client = parts[1];
    if (parts) {
      this.toastr.success(ToasterMessages.PdfProcessing);
      this.requestFormService
        .downloadPeriodicSummary(pdfFileName, client)
        .subscribe({
          next: (res: Blob) => {
            const blob = new Blob([res], { type: 'application/pdf' });
            this.overlayService.showPdf(blob);
            this.toastr.clear();
          },
          error: (err) => {
            this.toastr.clear();
            this.toastr.info(ToasterMessages.RecordNotFount);
            console.error('Download failed:', err);
          },
        });
    }
  }

  formatVesselName(name: string): string {
    if (!name) return '';

    return name
      .toLowerCase()
      .split(' ')
      .filter((word) => word.trim().length > 0)
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }
}
